// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-mon {
    display: grid;
    grid-template-rows: repeat(4, 1fr);
    gap: 10px; 
    width: 100%;
    height: 80vh;
    margin: 60px auto 0;
    box-sizing: border-box;
    overflow: auto;
}

.fila,
.sub-fila {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;
    gap: 10px; 
}

.caja {
    padding: 20px; 
    border: 1px solid #ddd;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    box-sizing: border-box; 
    flex: 2 1; 
    height: 100%;
}

.caja.full-width {
    flex: none;
    width: 100%;
    height: 130%;
}

.caja h5 {
    margin: 0;
    padding-bottom: 5px;
    font-size: 14px;
    text-align: center;
}

.iframe-container {
    width: 100%;
    height: 100%;
    padding: 10px; 
    box-sizing: border-box; 
}

iframe {
    width: 100%;
    height: 100%;
    border: none;
}

.logos-container-monitoreo {
    position: fixed; 
    bottom: 0; 
    left: 50%; 
    transform: translateX(-50%); 
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    z-index: 1000;
}

.logo-monitoreo {
    width: 50%;
    height: 80%; 
    margin: 0 -90px -70px; 
}

/* Pantallas Pequeñas */
@media (max-width: 768px) {
    .container-mon {
        grid-template-rows: repeat(4, auto); 
    }

    .caja {
        padding: 10px; 
    }

    .caja h5 {
        font-size: 10px; 
    }

    .logo-monitoreo {
        width: 60%; 
        margin: 0 -20px; 
    }
}

/* Pantallas Muy Pequeñas */
@media (max-width: 480px) {
    .container-mon {
        grid-template-rows: repeat(4, auto); 
    }

    .caja {
        padding: 5px; 
    }

    .caja h5 {
        font-size: 8px;
    }

    .logo-monitoreo {
        width: 100%; 
        margin: 0 -40px; 
    }
}

/* Pantallas Extra Grandes (largas y ultra-anchas) */
@media (min-width: 1800px) {
    .container-mon {
        grid-template-rows: repeat(4, 1fr); 
    }

    .caja {
        padding: 40px; 
    }

    .caja h5 {
        font-size: 18px; 
    }

    .logo-monitoreo {
        width: 50%; 
        margin: -70px -50px; 
    }
}

/* Pantallas Grandes */
@media (min-width: 1200px) and (max-width: 1799px) {
    .container-mon {
        grid-template-rows: repeat(4, 1fr); 
    }

    .caja {
        padding: 30px; 
    }

    .caja h5 {
        font-size: 16px; 
    }

    .logo-monitoreo {
        width: 50%;
        height: 80%; 
        margin: 0 -90px -70px; 
    }
}
`, "",{"version":3,"sources":["webpack://./src/css/MonitoreodeEntrenamiento.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,sBAAsB;IACtB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,qBAAqB;AACzB;;AAEA,uBAAuB;AACvB;IACI;QACI,mCAAmC;IACvC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,mCAAmC;IACvC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,oDAAoD;AACpD;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,sBAAsB;AACtB;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,qBAAqB;IACzB;AACJ","sourcesContent":[".container-mon {\n    display: grid;\n    grid-template-rows: repeat(4, 1fr);\n    gap: 10px; \n    width: 100%;\n    height: 80vh;\n    margin: 60px auto 0;\n    box-sizing: border-box;\n    overflow: auto;\n}\n\n.fila,\n.sub-fila {\n    display: flex;\n    flex-direction: row;\n    width: 100%;\n    height: 100%;\n    gap: 10px; \n}\n\n.caja {\n    padding: 20px; \n    border: 1px solid #ddd;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    box-sizing: border-box; \n    flex: 2; \n    height: 100%;\n}\n\n.caja.full-width {\n    flex: none;\n    width: 100%;\n    height: 130%;\n}\n\n.caja h5 {\n    margin: 0;\n    padding-bottom: 5px;\n    font-size: 14px;\n    text-align: center;\n}\n\n.iframe-container {\n    width: 100%;\n    height: 100%;\n    padding: 10px; \n    box-sizing: border-box; \n}\n\niframe {\n    width: 100%;\n    height: 100%;\n    border: none;\n}\n\n.logos-container-monitoreo {\n    position: fixed; \n    bottom: 0; \n    left: 50%; \n    transform: translateX(-50%); \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px;\n    z-index: 1000;\n}\n\n.logo-monitoreo {\n    width: 50%;\n    height: 80%; \n    margin: 0 -90px -70px; \n}\n\n/* Pantallas Pequeñas */\n@media (max-width: 768px) {\n    .container-mon {\n        grid-template-rows: repeat(4, auto); \n    }\n\n    .caja {\n        padding: 10px; \n    }\n\n    .caja h5 {\n        font-size: 10px; \n    }\n\n    .logo-monitoreo {\n        width: 60%; \n        margin: 0 -20px; \n    }\n}\n\n/* Pantallas Muy Pequeñas */\n@media (max-width: 480px) {\n    .container-mon {\n        grid-template-rows: repeat(4, auto); \n    }\n\n    .caja {\n        padding: 5px; \n    }\n\n    .caja h5 {\n        font-size: 8px;\n    }\n\n    .logo-monitoreo {\n        width: 100%; \n        margin: 0 -40px; \n    }\n}\n\n/* Pantallas Extra Grandes (largas y ultra-anchas) */\n@media (min-width: 1800px) {\n    .container-mon {\n        grid-template-rows: repeat(4, 1fr); \n    }\n\n    .caja {\n        padding: 40px; \n    }\n\n    .caja h5 {\n        font-size: 18px; \n    }\n\n    .logo-monitoreo {\n        width: 50%; \n        margin: -70px -50px; \n    }\n}\n\n/* Pantallas Grandes */\n@media (min-width: 1200px) and (max-width: 1799px) {\n    .container-mon {\n        grid-template-rows: repeat(4, 1fr); \n    }\n\n    .caja {\n        padding: 30px; \n    }\n\n    .caja h5 {\n        font-size: 16px; \n    }\n\n    .logo-monitoreo {\n        width: 50%;\n        height: 80%; \n        margin: 0 -90px -70px; \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
